// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"b9033f85","28":"c330583f","111":"96e613cb","128":"0dc1687a","528":"4f033e3e","602":"f0cb455d","678":"31d6cfe0","788":"4a38f99f"}[chunkId] + ".chunk.css";
};